export default defineNuxtPlugin(() => {
  const { isMobile } = useDevice()

  if (isMobile) {
    useHead({
      script: [
        {
          defer: true,
          fetchpriority: 'low',
          src: '/smartBanner.js',
          tagPriority: 'low',
        },
      ],
    })
  }
})
